export default __webpack_public_path__ + "static/media/mysql.17ec0131.png";